// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tabs_tabContainer__\\+LiAz {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 6px; /* Colțuri mai mici */
  background-color: #f9f9f9;
  margin-top: 20px;
  margin-bottom: 20px;
}

.Tabs_tabHeader__QqFxa {
  display: flex;
  justify-content: flex-start; /* Taburile aliniate la stânga */
  background-color: #f9f9f9;
  padding-left: 10px; /* Mic spațiu față de marginea stângă */
  margin-top: 15px; /* Adăugat spațiu deasupra taburilor */
}

.Tabs_tab__mqh-L {
  padding: 12px 20px; /* Adăugat padding mai mare pentru text */
  text-align: center;
  background-color: #f9f9f9;
  border: none;
  cursor: pointer;
  font-size: 16px; /* Textul este acum mai mare */
  color: #333;
  margin-right: 5px; /* Spațiu între taburi */
  transition: background-color 0.3s ease, color 0.3s ease,
    border-radius 0.3s ease;
}

.Tabs_tab__mqh-L:hover {
  background-color: #eaeaea;
}

.Tabs_activeTab__F48-j {
  background-color: #fff;
  color: #ff4500; /* Textul devine roșu pentru tab-ul activ */
  border: 1px solid #ddd;
  border-bottom: none; /* Eliminăm marginea de jos */
  border-radius: 4px 4px 0 0; /* Colțuri rotunjite subtile doar sus */
  z-index: 1; /* Pentru a se suprapune peste container */
  position: relative;
}

.Tabs_tabContent__fkdYc {
  padding: 15px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  border: 1px solid #ddd;
  border-top: none; /* Conținutul și tabul activ să pară conectate */
  border-radius: 0 0 4px 4px; /* Colțuri rotunjite subtile doar jos */
}

@media (max-width: 768px) {
  .Tabs_tabContent__fkdYc {
    padding: 5px;
    background-color: #fff;
    font-size: 14px;
    color: #333;
    border: 1px solid #ddd;
    border-top: none; /* Conținutul și tabul activ să pară conectate */
    border-radius: 0 0 4px 4px; /* Colțuri rotunjite subtile doar jos */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Product/ProductDetails/Tabs/Tabs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB,EAAE,qBAAqB;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B,EAAE,gCAAgC;EAC7D,yBAAyB;EACzB,kBAAkB,EAAE,uCAAuC;EAC3D,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA;EACE,kBAAkB,EAAE,yCAAyC;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe,EAAE,8BAA8B;EAC/C,WAAW;EACX,iBAAiB,EAAE,wBAAwB;EAC3C;2BACyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc,EAAE,2CAA2C;EAC3D,sBAAsB;EACtB,mBAAmB,EAAE,6BAA6B;EAClD,0BAA0B,EAAE,uCAAuC;EACnE,UAAU,EAAE,0CAA0C;EACtD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,gBAAgB,EAAE,gDAAgD;EAClE,0BAA0B,EAAE,uCAAuC;AACrE;;AAEA;EACE;IACE,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,gBAAgB,EAAE,gDAAgD;IAClE,0BAA0B,EAAE,uCAAuC;EACrE;AACF","sourcesContent":[".tabContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border: 1px solid #ddd;\n  border-radius: 6px; /* Colțuri mai mici */\n  background-color: #f9f9f9;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.tabHeader {\n  display: flex;\n  justify-content: flex-start; /* Taburile aliniate la stânga */\n  background-color: #f9f9f9;\n  padding-left: 10px; /* Mic spațiu față de marginea stângă */\n  margin-top: 15px; /* Adăugat spațiu deasupra taburilor */\n}\n\n.tab {\n  padding: 12px 20px; /* Adăugat padding mai mare pentru text */\n  text-align: center;\n  background-color: #f9f9f9;\n  border: none;\n  cursor: pointer;\n  font-size: 16px; /* Textul este acum mai mare */\n  color: #333;\n  margin-right: 5px; /* Spațiu între taburi */\n  transition: background-color 0.3s ease, color 0.3s ease,\n    border-radius 0.3s ease;\n}\n\n.tab:hover {\n  background-color: #eaeaea;\n}\n\n.activeTab {\n  background-color: #fff;\n  color: #ff4500; /* Textul devine roșu pentru tab-ul activ */\n  border: 1px solid #ddd;\n  border-bottom: none; /* Eliminăm marginea de jos */\n  border-radius: 4px 4px 0 0; /* Colțuri rotunjite subtile doar sus */\n  z-index: 1; /* Pentru a se suprapune peste container */\n  position: relative;\n}\n\n.tabContent {\n  padding: 15px;\n  background-color: #fff;\n  font-size: 14px;\n  color: #333;\n  border: 1px solid #ddd;\n  border-top: none; /* Conținutul și tabul activ să pară conectate */\n  border-radius: 0 0 4px 4px; /* Colțuri rotunjite subtile doar jos */\n}\n\n@media (max-width: 768px) {\n  .tabContent {\n    padding: 5px;\n    background-color: #fff;\n    font-size: 14px;\n    color: #333;\n    border: 1px solid #ddd;\n    border-top: none; /* Conținutul și tabul activ să pară conectate */\n    border-radius: 0 0 4px 4px; /* Colțuri rotunjite subtile doar jos */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContainer": `Tabs_tabContainer__+LiAz`,
	"tabHeader": `Tabs_tabHeader__QqFxa`,
	"tab": `Tabs_tab__mqh-L`,
	"activeTab": `Tabs_activeTab__F48-j`,
	"tabContent": `Tabs_tabContent__fkdYc`
};
export default ___CSS_LOADER_EXPORT___;
